let swipera;
window.globals = {};
const body = document.body,
lightboxImages = document.querySelectorAll("[lightbox-toggle] img"),
initLightbox = lightboxImages.length > 0,
createLightboxSkeleton = () =>{
    const lightbox = document.createElement("div");
    lightbox.classList.add("lalo-lightbox"),
    body.appendChild(lightbox);
    const lightboxContainer = document.createElement("div");
    lightboxContainer.classList.add("lalo-lightbox__container"),
    lightbox.appendChild(lightboxContainer);
    const lightboxClose = document.createElement("div");
    lightboxClose.classList.add("lalo-lightbox__close"),
    lightboxClose.setAttribute("tabindex", "0"),
    lightboxClose.innerHTML = '<i class="icon-close">X</i>',
    lightboxContainer.appendChild(lightboxClose);
    const swiperContainer = document.createElement("div");
    swiperContainer.classList.add("swiper"),
    lightboxContainer.appendChild(swiperContainer);
    const swiperWrapper = document.createElement("div");
    swiperWrapper.classList.add("swiper-wrapper"),
    swiperContainer.appendChild(swiperWrapper);
    const swiperBtnNext = document.createElement("div");
    swiperBtnNext.classList.add("swiper-button-next"),
    swiperContainer.appendChild(swiperBtnNext);
    const swiperBtnPrev = document.createElement("div");
    swiperBtnPrev.classList.add("swiper-button-prev"),
    swiperContainer.appendChild(swiperBtnPrev),
    globals.lightboxRef = document.querySelector(".lalo-lightbox"),
    globals.swiperWrapperRef = document.querySelector(".lalo-lightbox .swiper-wrapper")
};
if (initLightbox) {
    createLightboxSkeleton(),
    lightboxImages.forEach(function(el, index) {
        el.addEventListener("click", imageClick, !1);
        function imageClick() {
            globals.swiperWrapperRef.innerHTML = "",
            lightboxImages.forEach(function(img) {
                const image = img.cloneNode(!0),
                slide = document.createElement("div"),
                imageContainer = document.createElement("div");
                slide.classList.add("swiper-slide"),
                imageContainer.classList.add("lalo-lightbox__image"),
                imageContainer.appendChild(image),
                slide.appendChild(imageContainer),
                globals.swiperWrapperRef.appendChild(slide)
            }),
            swipera = new Swiper(".lalo-lightbox .swiper", {
                initialSlide: index,
                loop: !0,
                slidesPerView: 1,
                spaceBetween: 0,
                navigation: {
                    nextEl: ".lalo-lightbox .swiper-button-next",
                    prevEl: ".lalo-lightbox .swiper-button-prev"
                },
                keyboard: {
                    enabled: !0,
                    onlyInViewport: !0
                }
            }),
            globals.lightboxRef.classList.add("open"),
            body.classList.add("is-drawer-opened")
        }
    });
    let destroySwiper = (swiper2, timeout) =>{
        setTimeout(() =>{
            swiper2.destroy()
        },
        timeout)
    };
    document.addEventListener("click", ({
        target
    }) =>{
        target.matches(".lalo-lightbox__close *") && (destroySwiper(swipera, 250), globals.lightboxRef.classList.remove("open"), body.classList.remove("is-drawer-opened"))
    },
    !1),
    document.addEventListener("click",
    function(evt) {
        let laloLightbox = document.querySelector(".lalo-lightbox"),
        laloLightboxGrid = document.querySelector(".ugc-section[lightbox-toggle]");
        if (targetEl = evt.target, document.querySelector(".lalo-lightbox.open")) {
            do {
                if (targetEl == laloLightbox || targetEl == laloLightboxGrid) return;
                targetEl = targetEl.parentNode
            } while ( targetEl );
            destroySwiper(swipera, 250),
            globals.lightboxRef.classList.remove("open"),
            body.classList.remove("is-drawer-opened")
        }
    }),
    document.addEventListener("keydown", ({
        key
    }) =>{
        key === "Escape" && swipera && (destroySwiper(swipera, 250), globals.lightboxRef.classList.remove("open"), body.classList.remove("is-drawer-opened"))
    })
}